<div class="container-fluid pb-1 mx-auto" style="background-color: #567ba0; padding-left: 30px;">
    <div class="mx-auto">
        <p class="mb-0">
            <a [href]="'/home'" class="btn btn-xs text-light shadow-none align-middle px-0">
            <img src="./assets/images/arrow-left.svg" width="18px">
            Volver</a>
        </p>
      <h2 class="text-light mb-0">Solicitudes de código artículo</h2>
    </div>
</div>
    <form>
            <div class="datatable table-editor">
                <table
                    class="table datatable-table"
                    mdbTable
                    mdbTableSort
                    #table="mdbTable"
                    #sort="mdbTableSort"
                    [dataSource]="requestCodes"
                    [pagination]="pagination"
                    [sort]="sort"
                    width="100%"
                >
                    <thead class="datatable-header">
                        <tr>
                            <ng-container *ngFor="let header of headers">
                                <th
                                    [mdbTableSortHeader]="header.field"
                                    [disableSort]="header.disableSort"
                                    scope="col"
                                    class="py-2 align-middle th_3"
                                    style="white-space: normal;"
                                >
                                    <strong>{{ header.label.replace("_", " ") | titlecase }}</strong>
                                </th>
                            </ng-container>
                        </tr>
                    </thead>
                
                    <tbody class="datatable-body">
                        <tr *ngIf="loading">
                            <td colspan="5" class="p-0 pt-1">
                                <div class="px-2 bg-light py-5 text-center">
                                    <div width="150" class="spinner-border mt-5 opacity-50" role="status"></div>
                                    <p class="lead text-muted text-center mb-5">
                                        Cargando resultados...
                                    </p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    
                    <tbody class="datatable-body">
                        <tr
                            *ngFor="let register of requestCodesPaginated; let index = index"
                            scope="row"
                            [cdkTrapFocus]="editElementIndex === index"
                            [cdkTrapFocusAutoCapture]="editElementIndex === index"
                            [ngClass]="{ 'edited-row': editElementIndex === index }"
                        >
                            <td class="table-cell py-1 px-4" style="white-space: normal;">
                                <ng-container>
                                    <button class="btn btn-outline-success btn-sm w-100" type="button">{{ register.id }}</button>
                                </ng-container>
                            </td>
                            <td class="table-cell py-1 px-4" style="white-space: normal;">
                                <ng-container>
                                    {{ register.accounting_group }}
                                </ng-container>
                            </td>
                            <td class="table-cell py-1 px-4" style="white-space: normal;">
                                <ng-container>
                                    {{ register.commercial_group }}
                                </ng-container>
                            </td>
                            <td class="table-cell py-1 px-4" style="white-space: normal;">
                                <ng-container>
                                    {{ register.financial_group }}
                                </ng-container>
                            </td>
                            <td class="table-cell py-1 px-4" style="white-space: normal;">
                                <ng-container>
                                    {{ register.executive_group }}
                                </ng-container>
                            </td>
                            <td class="table-cell text-center py-1 px-2" style="max-width: 50px !important;">
                                <ng-container>
                                    <i [ngClass]="register.inventory_item ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger'"></i>
                                </ng-container>
                            </td>
                            <td class="table-cell text-center py-1 px-2" style="max-width: 50px !important;">
                                <ng-container>
                                    <i [ngClass]="register.inventory_sales ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger'"></i>
                                </ng-container>
                            </td>
                            <td class="table-cell text-center py-1 px-2" style="max-width: 50px !important;">
                                <ng-container>
                                    <i [ngClass]="register.inventory_shopping ? 'fas fa-check-circle text-success' : 'fas fa-times-circle text-danger'"></i>
                                </ng-container>
                            </td>
                            <td class="table-cell py-1 px-4" style="max-width: 50px !important;">
                                <ng-container>
                                    {{ register.management_method }}
                                </ng-container>
                            </td>
                            <td class="table-cell py-1 px-4">
                                <ng-container>
                                    {{ register.origin }}
                                </ng-container>
                            </td>
                            <td class="table-cell py-1 px-4">
                                <ng-container>
                                    {{ register.created_at }}
                                </ng-container>
                            </td>
                            <td class="table-cell text-center py-1 px-4">
                                <ng-container>
                                    <button *ngIf="register.status === '1'" class="btn btn-warning btn-sm w-100" type="button">En proceso</button>
                                    <button *ngIf="register.status === '2'" class="btn btn-success btn-sm w-100" type="button">Resuelta</button>
                                </ng-container>
                            </td>
                            <td class="table-cell text-center py-1 px-2">
                                <button class="btn btn-info btn-sm" type="button" (click)="seeRequestCode(register.id)">
                                    <i class="far fa-eye"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
        
                <mdb-table-pagination
                    #pagination
                    rowsPerPageText="Registros por Página"
                    ofText="de"
                    [disabled]="loading"
                    (paginationChange)="onPageChange($event)"
                ></mdb-table-pagination>
            </div>
    </form>

<mdb-loading [show]="loadingFull" [fullscreen]="true">
    <div class="loading-spinner">
        <div class="spinner-border loading-icon" role="status"></div>
        <span class="loading-text">Cargando datos...</span>
    </div>
</mdb-loading>